import moment from "moment";

export const DATE_PRESETS = [
  { label: "Last 7 Days", value: "last-7" },
  { label: "Last 30 Days", value: "last-30" },
  { label: "Last 90 Days", value: "last-90" },
  { label: "This Week", value: "this-week" },
  { label: "Last Week", value: "last-week" },
  { label: "This Month", value: "this-month" },
  { label: "Last Month", value: "last-month" },
  { label: "This Quarter", value: "this-quarter" },
  { label: "Last Quarter", value: "last-quarter" },
  { label: "Year to Date", value: "ytd" },
  { label: "This Year", value: "this-year" },
  { label: "Last Year", value: "last-year" },
  { label: "Custom", value: "custom" },
];

export const getPresetRange = (preset) => {
  const today = moment();
  switch (preset) {
    case "last-7":
      return [moment().subtract(7, "days"), today];
    case "last-30":
      return [moment().subtract(30, "days"), today];
    case "last-90":
      return [moment().subtract(90, "days"), today];
    case "this-week":
      return [moment().startOf("isoWeek"), today];
    case "last-week":
      return [
        moment().subtract(1, "week").startOf("isoWeek"),
        moment().subtract(1, "week").endOf("isoWeek"),
      ];
    case "this-month":
      return [moment().startOf("month"), today];
    case "last-month":
      return [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ];
    case "this-quarter":
      return [moment().startOf("quarter"), today];
    case "last-quarter":
      return [
        moment().subtract(1, "quarter").startOf("quarter"),
        moment().subtract(1, "quarter").endOf("quarter"),
      ];
    case "ytd":
      return [moment().startOf("year"), today];
    case "this-year":
      return [moment().startOf("year"), today];
    case "last-year":
      return [
        moment().subtract(1, "year").startOf("year"),
        moment().subtract(1, "year").endOf("year"),
      ];
    default:
      return null;
  }
};
